/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionsActionItemResponse
 */
export interface PermissionsActionItemResponse {
    /**
     * 
     * @type {string}
     * @memberof PermissionsActionItemResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsActionItemResponse
     */
    value: boolean;
}

/**
 * Check if a given object implements the PermissionsActionItemResponse interface.
 */
export function instanceOfPermissionsActionItemResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PermissionsActionItemResponseFromJSON(json: any): PermissionsActionItemResponse {
    return PermissionsActionItemResponseFromJSONTyped(json, false);
}

export function PermissionsActionItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionsActionItemResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function PermissionsActionItemResponseToJSON(value?: PermissionsActionItemResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

